<template>
  <div>
    <button
      class="d-none"
      data-toggle="modal"
      data-target="#EditTournament"
      ref="openModalEditTournament"
    ></button>
    <div class="modal fade" tabindex="-1" role="dialog" id="EditTournament">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h6 class="modal-title m-0">Update Division</h6>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
              ref="closeModalAddTournament"
            >
              <img src="../../../assets/Svg/close.svg" />
            </button>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <input
                id="name"
                class="form-control"
                v-model="tournament_name"
                spellcheck="false"
                autocomplete="off"
                trim
                type="text"
                required
                @input="errorNull"
              />
              <span class="placeholder">Division Name</span>
            </div>

            <div class="row no-gutters">
              <div class="col-sm-12 col-md-6 pr-0 pr-md-2">
                <div class="form-group" :class="{ filled: startDate }">
                  <span class="event-error" v-if="startDateError != ''">
                    Please select Start Date.
                  </span>
                  <span class="event-error" v-if="eventStartDateError != ''">
                    Start date is outside the event date range.
                  </span>
                  <date-picker
                    :open="open"
                    @close="open = false"
                    :editable="false"
                    :clearable="false"
                    @click.native="open = true"
                    v-model="startDateForField"
                    valueType="format"
                    format="MMM DD, YYYY"
                    @change="checkdate"
                  >
                    <i slot="icon-calendar" class="cursor-pointer">
                      <img src="../../../assets/Svg/calendar.svg" />
                    </i>
                  </date-picker>
                  <span class="placeholder">Start Date</span>
                </div>
              </div>
              <div class="col-sm-12 col-md-6 pl-lg-0">
                <div class="form-group" :class="{ filled: endDate }">
                  <span
                    class="event-error"
                    v-if="endDate == '' && endDateError != ''"
                  >
                    Please select End Date.
                  </span>
                  <span class="event-error" v-if="endDateErrorGreater != ''">
                    End Date should be greater than start date
                  </span>
                  <span class="event-error" v-if="eventEndDateError != ''">
                    End date is outside the event date range.
                  </span>
                  <date-picker
                    :open="openEnd"
                    @close="openEnd = false"
                    :editable="false"
                    :clearable="false"
                    @click.native="openEnd = true"
                    v-model="endDateForField"
                    valueType="format"
                    format="MMM DD, YYYY"
                    @change="checkdate"
                  >
                    <i slot="icon-calendar" class="cursor-pointer">
                      <img src="../../../assets/Svg/calendar.svg" />
                    </i>
                  </date-picker>
                  <span class="placeholder">End Date</span>
                </div>
              </div>
            </div>

            <!-- <div class="col-12 p-0">
              <div class="form-group">
                <input id="time_limit" class="form-control" v-model="tournament_time" spellcheck="false"
                  autocomplete="off" trim type="number" required />
                <span class="placeholder">Time Limit (minutes)</span>
              </div>
            </div> -->

            <div class="col-12 p-0 mb-3">
              <h6 class="mb-2 head-sec">Format</h6>
              <div class="d-flex align-items-center justify-content-between">
                <span class="custom-format"
                  >Use custom format for this division</span
                >
                <toggle-button
                  type="checkbox"
                  class="m-0 p-0  d-flex justify-content-end"
                  id="customFormat"
                  :width="34"
                  :sync="true"
                  :value="customFormat"
                  v-model="customFormat"
                />
              </div>
            </div>

            <div class="row no-gutters" v-if="customFormat">
              <div class="col-12 col-md-6 pr-md-2">
                <div class="form-group">
                  <span class="event-error" v-if="showErrors && !poolPlay">
                    Please select pool play guaranteed.
                  </span>
                  <select
                    class="form-control"
                    :class="{ filled: poolPlay }"
                    v-model="poolPlay"
                  >
                    <option
                      v-for="option in gameGuaranteeOptions"
                      :key="option.id"
                      :value="option.id"
                    >
                      {{ option.value }}
                    </option>
                  </select>
                  <span class="placeholder">Pool Play Guaranteed</span>
                </div>
              </div>
              <div class="col-12 col-md-6">
                <div class="form-group">
                  <span class="event-error" v-if="showErrors && !bracketFormat">
                    Please select bracket format.
                  </span>
                  <select
                    class="form-control"
                    :class="{ filled: bracketFormat }"
                    v-model="bracketFormat"
                    :key="bracketFormat?.id"
                  >
                    <option
                      v-for="option in bracketFormats"
                      :key="option.id"
                      :value="option"
                    >
                      {{ option.bracket_name }}
                    </option>
                  </select>
                  <span class="placeholder">Bracket Format</span>
                </div>
              </div>
            </div>

            <div class="col-12 p-0">
              <h6 class="mb-3 head-sec">Time Limits (minutes)</h6>
              <div class="row no-gutters">
                <div class="col-12 col-lg-4">
                  <div class="form-group" :class="{ filled: poolPlayTime }">
                    <input
                      type="text"
                      class="form-control"
                      id="poolPlayTime"
                      v-model="poolPlayTime"
                      required
                    />
                    <span class="placeholder">Pool Play</span>
                  </div>
                </div>

                <div class="col-12 col-lg-4 px-lg-2">
                  <div class="form-group" :class="{ filled: bracketTime }">
                    <input
                      type="text"
                      class="form-control"
                      id="bracketTime"
                      v-model="bracketTime"
                      required
                    />
                    <span class="placeholder">Bracket</span>
                  </div>
                </div>

                <div class="col-12 col-lg-4">
                  <div class="form-group" :class="{ filled: championshipTime }">
                    <input
                      type="text"
                      class="form-control"
                      id="championshipTime"
                      v-model="championshipTime"
                      required
                    />
                    <span class="placeholder">Championship</span>
                  </div>
                </div>
              </div>
            </div>
            <!-- <div class="form-check">
              <input class="form-check-input" type="checkbox" id="defaultCheck1" v-model="isChecked" />
              <label class="form-check-label" for="defaultCheck1" style="margin-top: 2px;">
                Add specific age & division
              </label>
            </div> -->
            <div class="col-12 px-0 pt-0 pb-3">
              <h6 class="mb-2 head-sec">Teams</h6>
              <div class="d-flex align-items-center justify-content-between">
                <span class="custom-format">
                  Only teams of specific ages and ratings will play in this
                  division
                </span>
                <toggle-button
                  type="checkbox"
                  class="m-0 p-0 d-flex justify-content-end"
                  id="isChecked"
                  :width="34"
                  :sync="true"
                  :value="isChecked"
                  v-model="isChecked"
                />
              </div>
            </div>

            <div class="row no-gutters my-3" v-if="isChecked">
              <!-- Age Group Multi-Select -->
              <div class="col-12">
                <div class="member-select">
                  <span
                    class="label-type error event-error ml-2"
                    v-if="showErrors && (!selectedAge || !selectedAge.length)"
                  >
                    Please select age.
                  </span>
                  <label class="typo__label" for="ajax">Age</label>
                  <multiselect
                    v-model="selectedAge"
                    :options="ageOptions"
                    open-direction="top"
                    :multiple="true"
                    :searchable="false"
                    track-by="id"
                    placeholder="Select Age"
                    label="name"
                    :internal-search="false"
                    :clear-on-select="false"
                    :close-on-select="false"
                    :options-limit="300"
                    :max-height="600"
                    :hide-selected="true"
                    class="select-friends"
                    :class="{
                      'is-invalid':
                        showErrors && (!selectedAge || !selectedAge.length),
                    }"
                  >
                    <template slot="tag" slot-scope="{ option, remove }">
                      <span class="custom__tag">
                        <div class="custom__content">
                          <span class="user__name text-capitalize">{{
                            option.name
                          }}</span>
                        </div>
                        <span
                          class="custom__remove cursor-pointer"
                          v-on:click="remove(option)"
                        >
                          <img src="../../../assets/Svg/close.svg" alt="" />
                        </span>
                      </span>
                    </template>
                    <template slot="clear" slot-scope="props">
                      <div
                        class="multiselect__clear"
                        v-if="selectedAge.length"
                        @mousedown.prevent.stop="clearAll(props.search)"
                      ></div>
                    </template>
                    <template slot="noResult"
                      >No matching ages found. Try refining your
                      search!</template
                    >
                    <template slot="noOptions"
                      >No more ages to choose from.</template
                    >
                    <template slot="option" slot-scope="{ option }">
                      <div class="option__desc">
                        <span class="text-capitalize">{{ option.name }}</span>
                      </div>
                    </template>
                  </multiselect>
                </div>
              </div>

              <!-- Division (Rating) Multi-Select -->
              <div class="col-12 pt-3">
                <div class="member-select">
                  <span
                    class="label-type error event-error ml-2"
                    v-if="
                      showErrors &&
                        (!selectedDivision || !selectedDivision.length)
                    "
                  >
                    Please select rating.
                  </span>
                  <label class="typo__label" for="ajax">Rating</label>
                  <multiselect
                    v-model="selectedDivision"
                    :options="ratingOptions"
                    track-by="id"
                    label="rate"
                    placeholder="Select Rating"
                    open-direction="top"
                    :multiple="true"
                    :searchable="false"
                    :internal-search="false"
                    :clear-on-select="false"
                    :close-on-select="false"
                    :options-limit="300"
                    :max-height="600"
                    :hide-selected="true"
                    class="select-friends"
                    :class="{
                      'is-invalid':
                        showErrors &&
                        (!selectedDivision || !selectedDivision.length),
                    }"
                  >
                    <template slot="tag" slot-scope="{ option, remove }">
                      <span class="custom__tag">
                        <div class="custom__content">
                          <span class="user__name text-capitalize">{{
                            option.rate
                          }}</span>
                        </div>
                        <span
                          class="custom__remove cursor-pointer"
                          v-on:click="remove(option)"
                        >
                          <img src="../../../assets/Svg/close.svg" alt="" />
                        </span>
                      </span>
                    </template>
                    <template slot="clear" slot-scope="props">
                      <div
                        class="multiselect__clear"
                        v-if="selectedDivision.length"
                        @mousedown.prevent.stop="clearAll(props.search)"
                      ></div>
                    </template>
                    <template slot="noResult"
                      >No matching rating found. Try refining your
                      search!</template
                    >
                    <template slot="noOptions"
                      >No more rating to choose from.</template
                    >
                    <template slot="option" slot-scope="{ option }">
                      <div class="option__desc">
                        <span class="text-capitalize">{{ option.rate }}</span>
                      </div>
                    </template>
                  </multiselect>
                </div>
              </div>
            </div>

            <!-- <div class="form-group">
              <input type="text" class="form-control" id="tournamentFormat" v-model="tournamentFormat"
                @keyup="errorNull" required />
              <span class="placeholder">Tournament Format</span>
            </div> -->

            <div class="form-group">
              <textarea
                type="text"
                class="form-control"
                id="tournamentNotes"
                v-model="tournamentNotes"
                @keyup="errorNull"
                required
                rows="4"
              ></textarea>
              <span class="placeholder">Notes</span>
            </div>

            <!-- <div class="col-12 p-0">
              <div>
                <label for="summernote">Tournament Format</label>
                <vue-editor v-model="tournamentFormat" :editorToolbar="customToolbar"></vue-editor>
              </div>
           </div> -->
          </div>
          <div class="event-btns-wrapper pt-3 justify-content-between">
            <button
              type="button"
              class="btn btn-danger delte-btn"
              block
              @click="deleteTournament(0)"
              :disabled="isDeleteButtonDisabled || isLoadingArrayDelete[0]"
            >
              <div v-if="isLoadingArrayDelete[0]" class="lds-dual-ring"></div>
              <span v-else class="">
                <img src="../../../assets/Svg/trash.svg" />
                Delete
              </span>
            </button>
            <button
              type="button"
              class="btn btn-primary"
              @click="editTournament(0)"
            >
              <div v-if="isLoadingArray[0]" class="lds-dual-ring"></div>
              <span v-else>
                <img src="../../../assets/Svg/save.svg" alt="save">
                Update</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Multiselect from "vue-multiselect";
import { required } from "vuelidate/lib/validators";

// import { VueEditor, Quill } from 'vue2-editor';

// function getFontName(font) {
//     return font.toLowerCase().replace(/\s/g, "-");
// }

// // Specify Quill fonts
// const fontList = ['Arial', 'Courier', 'Garamond', 'Tahoma', 'Times New Roman', 'Verdana', 'sans-serif', 'Serif', 'Monospace'];
// const fontNames = fontList.map(font => getFontName(font));
// const fonts = Quill.import('formats/font');
// fonts.whitelist = fontNames;
// Quill.register(fonts, true);

// // Add fonts to CSS style
// let fontStyles = "";
// fontList.forEach(function(font) {
//     let fontName = getFontName(font);
//     fontStyles += ".ql-snow .ql-picker.ql-font .ql-picker-label[data-value=" + fontName + "]::before, .ql-snow .ql-picker.ql-font .ql-picker-item[data-value=" + fontName + "]::before {" +
//         "content: '" + font + "';" +
//         "font-family: '" + font + "', sans-serif;" +
//         "}" +
//         ".ql-font-" + fontName + "{" +
//         " font-family: '" + font + "', sans-serif;" +
//         "}";
// });
// const node = document.createElement('style');
// node.innerHTML = fontStyles;
// document.body.appendChild(node);

export default {
  name: "EditTournament",
  components: {
    // VueEditor
    Multiselect,
  },
  data() {
    return {
      open: false,
      openEnd: false,
      startDate: "",
      endDate: "",
      startDateForField: "",
      endDateForField: "",
      exactStartDate: "",
      exactEndDate: "",
      startDateError: "",
      tournament_time: "",
      tournament_name: "",
      tournamentFormat: "",
      tournamentNotes: "",
      isChecked: false,
      endDateError: "",
      endDateErrorGreater: "",
      eventStartDateError: "",
      eventEndDateError: "",
      exactStartDateformat: "",
      exactEndDateformat: "",
      isDisabled: true,
      isLoadingArray: [],
      isUpdateButtonDisabled: false,
      isDeleteButtonDisabled: false,
      isLoadingArrayDelete: [],
      selectedTournament: null,
      events_id: "",
      event_guid: "",
      // customToolbar: [
      //   ["bold", "italic", "underline", "strike"],
      //   [{ list: "ordered" }, { list: "bullet" }],
      //   [{ header: [false, 1, 2, 3, 4, 5, 6] }],
      //   [{ font: fonts.whitelist }],
      //   // [{ font: [] }],
      //   // [{ size: ["small", false, "large", "huge"] }],
      //   [{ align: [] }],
      //   [{ color: [] }, { background: [] }],
      //   // ["link", "image", "video"],
      //   // ["code-block"],
      //   // ["clean"]
      // ],
      selectedAge: "", // Holds the selected age
      selectedDivision: "", // Holds the selected division
      showErrors: false,
      customFormat: false,
      poolPlay: "",
      bracketFormat: null,
      bracketFormats: [],
      gameGuaranteeOptions: [
        { value: "1", id: "1" },
        { value: "2", id: "2" },
        { value: "3", id: "3" },
        { value: "4", id: "4" },
        { value: "5", id: "5" },
      ],
      poolPlayTime: "",
      bracketTime: "",
      championshipTime: "",
    };
  },
  validations() {
    return {
      tournament_name: { required },
    };
  },
  props: {
    eventId: {
      type: Number,
    },
    association_id: {
      type: Number,
    },
    eventExactStartDate: {
      type: String,
    },
    eventExactEndDate: {
      type: String,
    },
    ratingOptions: {
      type: Array,
    },
    ageOptions: {
      type: Array,
    },
    // bracketFormats: {
    //   type: Array,
    // },
  },
  watch: {
    tournament_name: "errorNull",
    startDate: "checkdate",
    endDate: "checkdate",
    tournamentFormat: "errorNull",
    startDateForField(newVal) {
      this.startDate = newVal;
      this.checkdate();
    },
    endDateForField(newVal) {
      this.endDate = newVal;
      this.checkdate();
    },
    isChecked(newValue) {
      // If the checkbox is unchecked, hide the errors
      if (!newValue) {
        this.selectedAge = [];
        this.selectedDivision = [];
        this.showErrors = false;
      }
    },
    customFormat(newValue) {
      // If the checkbox is unchecked, hide the errors
      if (!newValue) {
        this.poolPlay = "";
        this.bracketFormat = "";
        this.showErrors = false;
      }
    },
  },
  methods: {
    deleteTournament(index) {
      this.$confirm(
        `About to delete the division (${this.tournament_name}). This will also remove all associated teams with the pool.  continue ?`
      )
        .then(() => {
          this.isUpdateButtonDisabled = true;
          this.isDeleteButtonDisabled = true;
          this.$set(this.isLoadingArrayDelete, index, true);

          const formData = {
            event_id: this.eventId ? this.eventId : this.events_id,
            tournament_id: this.selectedTournament.id,
            association_id: this.association_id,
          };

          axios
            .post("/associationEvent/deletedTournament", formData)
            .then((response) => {
              if (response.data.statusCode === 200) {
                this.$alert(`Division ${this.tournament_name} deleted`);
                const currentUrl = window.location.href;
                if (currentUrl.includes("tournament")) {
                  this.$root.$emit("fetchTournaments1", this.event_guid);
                } else {
                  this.$root.$emit("fetchTournaments");
                  this.$root.$emit("ReloadTabs"); // Refresh tournaments
                  localStorage.removeItem("tournamentID");
                  localStorage.removeItem("tournament_id");
                  localStorage.removeItem("division");
                }
                this.$refs.closeModalAddTournament.click();
                // Parse the current URL to get the tournament ID
                var url = window.location.pathname;

                if (url.includes("tournament")) {
                  this.$router.push({
                    name: "AssociationSingleEventDetail",
                    params: { id: this.selectedTournament?.event?.guid },
                  });
                }
              } else if (response.data.statusCode === 403) {
                this.$alert(
                  `Division ${this.tournament_name} can not be deleted. In order to delete this division, please remove all teams and games created under this division.`
                );
                // this.$router.push({ name: "Teams" });
                this.$refs.closeModalAddTournament.click();
              }
            });
        })
        .catch((error) => {
          // Handle the error and alert the incoming API message
          if (
            error.response &&
            error.response.data &&
            error.response.data.message
          ) {
            this.$alert(error.response.data.message);
          } else {
            this.$alert("An error occurred while deleting the tournament.");
          }
        })
        .finally(() => {
          // Always reset the loading state and button states
          this.$set(this.isLoadingArrayDelete, index, false);
          this.isUpdateButtonDisabled = false;
          this.isDeleteButtonDisabled = false;
        });
    },
    editTournament(index) {
      this.$v.$touch();
      if (
        this.$v.$pending ||
        this.$v.$error ||
        this.$v.$invalid ||
        (this.isChecked &&
          (!this.selectedAge ||
            !this.selectedAge.length ||
            !this.selectedDivision ||
            !this.selectedDivision.length))
      ) {
        if (
          this.isChecked &&
          (!this.selectedAge ||
            !this.selectedAge.length ||
            !this.selectedDivision ||
            !this.selectedDivision.length)
        ) {
          this.showErrors = true; // show validation errors
        }
        return;
      }

       if (this.eventStartDateError !== '' || this.eventEndDateError !== ''  || this.endDateErrorGreater !== '') {
        return
      }

      const rawStart = this.exactStartDate || this.startDate;
      const rawEnd = this.exactEndDate || this.endDate;

      // Parse once to ensure consistency
      const startDate = this.parseDate(rawStart);
      const endDate = this.parseDate(rawEnd);

      if (this.isChecked) {
        if (
          !this.selectedAge ||
          !this.selectedAge.length ||
          !this.selectedDivision ||
          !this.selectedDivision.length
        ) {
          this.showErrors = true; // show validation errors
          return;
        } else {
          const formData = {
            event_id: this.eventId ? this.eventId : this.events_id,
            tournamentName: this.tournament_name,
            time_limit: this.tournament_time,
            format: this.tournamentFormat,
            notes: this.tournamentNotes,
            tournament_id: this.selectedTournament.id,
            startDate: this.formatToUTCWithTime(startDate),
            endDate: this.formatToUTCWithTime(endDate),
            startDateForField: this.startDate
              ? this.formatDateForDB(this.startDate)
              : "",
            endDateForField: this.endDate
              ? this.formatDateForDB(this.endDate)
              : "",
            exactStartDate:
              this.exactStartDate || this.formatDate(this.startDate),
            exactEndDate: this.exactEndDate || this.formatDate(this.endDate),
            association_id: this.association_id,
            rate_id: this.selectedDivision.length
              ? this.selectedDivision.map((item) => item.id).join(",")
              : "0",
            age_group: this.selectedAge.length
              ? this.selectedAge.map((item) => item.id).join(",")
              : "",
            customFormat: this.customFormat,
            pool_play: this.customFormat ? this.poolPlay : "",
            bracket_format: this.customFormat ? this.bracketFormat.id : "",
            pool_play_time: this.poolPlayTime ? this.poolPlayTime : 65,
            bracket_time: this.bracketTime ? this.bracketTime : 70,
            championship_time: this.championshipTime
              ? this.championshipTime
              : 80,
          };
          this.$set(this.isLoadingArray, index, true);
          this.isUpdateButtonDisabled = true;
          this.isDeleteButtonDisabled = true;
          axios
            .post("/associationEvent/updatedTournament", formData)
            .then((response) => {
              // Handle response based on statusCode
              if (response.data.statusCode === 200) {
                // Success scenario
                const currentUrl = window.location.href;

                if (currentUrl.includes("tournament")) {
                  this.$root.$emit("fetchTournaments1", this.event_guid);
                } else {
                  this.$root.$emit("fetchTournaments");
                }
                this.$refs.closeModalAddTournament.click();
                this.dataReset();
              } else if (response.data.statusCode === 404) {
                this.$refs.closeModalAddTournament.click();
                this.$alert(response.data.message, "Error");
                this.$router.push({ name: "Teams" });
              } else {
                // Other error scenarios
                console.error(
                  response.data.message || "Unknown error occurred"
                );
              }
            })
            .catch((error) => {
              // Handle network or other errors
              console.error(error);
            })
            .finally(() => {
              this.$set(this.isLoadingArray, index, false);
              this.isUpdateButtonDisabled = false;
              this.isDeleteButtonDisabled = false;
            });
        }
      } else {
        const formData = {
          event_id: this.eventId ? this.eventId : this.events_id,
          tournamentName: this.tournament_name,
          time_limit: this.tournament_time,
          format: this.tournamentFormat,
          notes: this.tournamentNotes,
          tournament_id: this.selectedTournament.id,
          startDate: this.formatToUTCWithTime(startDate),
          endDate: this.formatToUTCWithTime(endDate),
          startDateForField: this.startDate
            ? this.formatDateForDB(this.startDate)
            : "",
          endDateForField: this.endDate
            ? this.formatDateForDB(this.endDate)
            : "",
          exactStartDate:
            this.exactStartDate || this.formatDate(this.startDate),
          exactEndDate: this.exactEndDate || this.formatDate(this.endDate),
          association_id: this.association_id,
          customFormat: this.customFormat,
          pool_play: this.customFormat ? this.poolPlay : "",
          bracket_format: this.customFormat ? this.bracketFormat.id : "",
          rate_id: 0,
          age_group: "",
          pool_play_time: this.poolPlayTime ? this.poolPlayTime : 65,
          bracket_time: this.bracketTime ? this.bracketTime : 70,
          championship_time: this.championshipTime ? this.championshipTime : 80,
        };
        console.log(this.formData), this.$set(this.isLoadingArray, index, true);
        this.isUpdateButtonDisabled = true;
        this.isDeleteButtonDisabled = true;
        axios
          .post("/associationEvent/updatedTournament", formData)
          .then((response) => {
            // Handle response based on statusCode
            if (response.data.statusCode === 200) {
              // Success scenario

              const currentUrl = window.location.href;

              if (currentUrl.includes("tournament")) {
                this.$root.$emit("fetchTournaments1", this.event_guid);
              } else {
                this.$root.$emit("fetchTournaments");
              }
              this.$refs.closeModalAddTournament.click();
              this.dataReset();
            } else if (response.data.statusCode === 404) {
              this.$refs.closeModalAddTournament.click();
              this.$alert(response.data.message, "Error");
              this.$router.push({ name: "Teams" });
            } else {
              // Other error scenarios
              console.error(response.data.message || "Unknown error occurred");
            }
          })
          .catch((error) => {
            // Handle network or other errors
            console.error(error);
          })
          .finally(() => {
            this.$set(this.isLoadingArray, index, false);
            this.isUpdateButtonDisabled = false;
            this.isDeleteButtonDisabled = false;
          });
      }
    },
    errorNull() {
      if (
        !this.tournament_name ||
        !this.startDate ||
        !this.endDate ||
        !this.eventStartDateError ||
        !this.eventEndDateError ||
        this.endDateErrorGreater !== ""
      ) {
        this.isUpdateButtonDisabled = false;
      } else {
        this.isUpdateButtonDisabled = true;
      }
    },

    checkdate: function() {
      const monthNames = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];

      const eventExactStart = new Date(this.eventExactStartDate);
      const eventExactEnd = new Date(this.eventExactEndDate);

      // ✅ START DATE
      if (this.startDate) {
        const startDateConvert = new Date(this.startDate);
        const startMonth = startDateConvert.getMonth();
        const startDay = startDateConvert.getDate();
        const startYear = startDateConvert.getFullYear();

        this.exactStartDateformat = startDateConvert;
        this.exactStartDate = `${monthNames[startMonth]} ${String(
          startDay
        ).padStart(2, "0")}, ${startYear}`;

        this.eventStartDateError =
          startDateConvert < eventExactStart || startDateConvert > eventExactEnd
            ? "on"
            : "";
      }

      // ✅ END DATE
      if (this.endDate) {
        const endDateConvert = new Date(this.endDate);
        const endMonth = endDateConvert.getMonth();
        const endDay = endDateConvert.getDate();
        const endYear = endDateConvert.getFullYear();

        if (
          endDateConvert < eventExactStart ||
          endDateConvert > eventExactEnd
        ) {
          this.eventEndDateError = "End date is outside the event range.";
        } else {
          this.eventEndDateError = "";
        }

        if (
          endDateConvert < this.exactStartDateformat &&
          !this.eventEndDateError &&
          !this.eventStartDateError
        ) {
          this.endDateError = "";
          this.endDateErrorGreater = "on";
          this.exactEndDate = "";
          this.isDisabledEvent = true;
        } else {
          this.endDateError = "";
          this.endDateErrorGreater = "";
          this.exactEndDate = `${monthNames[endMonth]} ${String(
            endDay
          ).padStart(2, "0")}, ${endYear}`;
        }
      }

      this.checkTimeDate();
    },

    formatDateForField(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },
    parseDate(input) {
      if (!input) return null;

      // Handle "May 10, 2025" format
      if (
        typeof input === "string" &&
        /^[A-Za-z]{3} \d{1,2}, \d{4}$/.test(input)
      ) {
        return new Date(input);
      }
      // Handle ISO strings
      return new Date(input);
    },

    // Format to ISO with 19:00 UTC without timezone shifts
    formatToUTCWithTime(date) {
      if (!date) return null;
      const d = this.parseDate(date);
      return new Date(
        Date.UTC(d.getFullYear(), d.getMonth(), d.getDate(), 19, 0, 0, 0)
      ).toISOString();
    },
    checkTimeDate() {
      if (!this.exactStartDate && this.exactEndDate) {
        this.startDateError = "on";
      } else {
        this.startDateError = "";
      }

      if (!this.exactEndDate && this.exactStartDate) {
        this.endDateError = "on";
      } else {
        this.endDateError = "";
      }

      // if (this.exactStartDate && this.exactEndDate) {
      this.errorNull();
      // }
    },
    dataReset() {
      this.startDate = "";
      this.endDate = "";
      this.startDateForField = "";
      this.endDateForField = "";
      this.exactStartDate = "";
      this.exactEndDate = "";
      this.startDateError = "";
      this.eventStartDateError = "";
      this.eventEndDateError = "";
      this.endDateError = "";
      this.endDateErrorGreater = "";
      this.isUpdateButtonDisabled = false;
      this.showErrors = false;
    },
    // initializeDate() {
    //   // Ensure the date is valid and set it to the date picker
    //   if (this.exactStartDateformat) {
    //     this.startDateForField = this.formatDate(this.exactStartDateformat);
    //   }
    //   if (this.exactEndDateformat) {
    //     this.endDateForField = this.formatDate(this.exactEndDateformat);
    //   }
    // },

    formatDate(dateString) {
      if (!dateString || typeof dateString !== "string") return null;

      const [year, month, day] = dateString.split("-");

      if (!year || !month || !day) return null;

      const yearNum = parseInt(year, 10);
      const monthNum = parseInt(month, 10);
      const dayNum = parseInt(day, 10);

      if (
        isNaN(yearNum) ||
        isNaN(monthNum) ||
        isNaN(dayNum) ||
        monthNum < 1 ||
        monthNum > 12 ||
        dayNum < 1 ||
        dayNum > 31
      ) {
        return null;
      }

      const monthNames = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];
      const monthStr = monthNames[monthNum - 1];
      const dayStr = dayNum < 10 ? `0${dayNum}` : `${dayNum}`;

      return `${monthStr} ${dayStr}, ${yearNum}`;
    },
    formatDateForDB(date) {
      if (!date) return null;
      const d = new Date(date);
      return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(
        2,
        "0"
      )}-${String(d.getDate()).padStart(2, "0")}`;
    },
  },

  mounted() {
    this.$root.$on(
      "openTournamentEditModal",
      ({ tournament, bracketFormats }) => {
        this.selectedTournament = tournament;
        this.events_id = tournament.event_id;
        this.event_guid = tournament?.event?.guid;
        this.tournament_name = tournament.tournamentName;
        this.tournament_time = tournament.time_limit;
        this.tournamentFormat = tournament.format;
        this.tournamentNotes = tournament.notes;
        this.poolPlayTime = tournament.pool_play_time;
        this.bracketTime = tournament.bracket_time;
        this.championshipTime = tournament.championship_time;

        // Handle dates
        this.startDateForField =
          tournament.exactStartDate || this.formatDate(tournament.startDate);
        this.endDateForField =
          tournament.exactEndDate || this.formatDate(tournament.endDate);
        this.startDate = this.startDateForField;
        this.endDate = this.endDateForField;

        // Age groups
        if (Array.isArray(tournament.age_groups)) {
          const ageGroupIds = tournament.age_groups.map((ag) => ag.id);
          this.selectedAge = this.ageOptions.filter((a) =>
            ageGroupIds.includes(a.id)
          );
        } else if (
          tournament.age_groups !== null &&
          tournament.age_groups !== undefined
        ) {
          this.selectedAge = this.ageOptions.filter(
            (a) => a.id === tournament.age_groups
          );
        } else {
          this.selectedAge = [];
        }

        // Ratings / divisions
        if (Array.isArray(tournament.ratings)) {
          const ratingIds = tournament.ratings.map((r) => r.id);
          this.selectedDivision = this.ratingOptions.filter((r) =>
            ratingIds.includes(r.id)
          );
        } else if (
          tournament.ratings !== null &&
          tournament.ratings !== undefined
        ) {
          this.selectedDivision = this.ratingOptions.filter(
            (r) => r.id === tournament.ratings
          );
        } else {
          this.selectedDivision = [];
        }

        this.isChecked =
          this.selectedAge.length > 0 || this.selectedDivision.length > 0;
        this.customFormat = tournament.custom_format === "1";
        this.poolPlay = tournament.pool_game_guarantee || null;

        // ✅ Assign bracketFormats directly from emit
        this.bracketFormats = bracketFormats;

        if (Array.isArray(this.bracketFormats)) {
          this.bracketFormat =
            this.bracketFormats.find(
              (b) => Number(b.id) === Number(tournament.bracket_format)
            ) || null;
        } else {
          this.bracketFormat = null;
        }

        this.$refs.openModalEditTournament.click();
      }
    );
  },
};
</script>

<style scoped>
.btn-danger,
.event-btns-wrapper .btn-danger {
  background-color: #ffdee0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  color: #dc3545;
  min-width: 90px;
}

.event-btns-wrapper .btn-danger img {
  width: 16px;
  filter: brightness(10);
  -webkit-filter: none;
  margin-right: 5px;
}

div.form-group,
.form-check {
  text-align: start !important;
}
</style>
